<div
  *ngIf="isOpen"
  class="modal-shell-backdrop fixed inset-0 z-50 flex items-center justify-center"
  (click)="onBackdropClick()">
  <div class="w-full" [ngClass]="panelClass" (click)="$event.stopPropagation()">
    <div class="modal-shell-panel flex flex-col overflow-hidden rounded-md border border-gray-200 bg-white shadow-2xl dark:border-gray-700 dark:bg-gray-800">

      <div class="modal-shell-header flex items-start justify-between gap-3 border-b border-gray-200 px-4 py-4 dark:border-gray-700">
    <div class="pt-[0.02rem] min-w-0">
      <h2 class="text-[1.08rem] font-medium leading-[1.45rem] tracking-[-0.01em] text-gray-900 dark:text-gray-100">
      {{ title }}
          </h2>
          <ng-content select="[headerContent]"></ng-content>
    </div>

        <button
          type="button"
          (click)="fechado.emit()"
          class="inline-flex h-[1.9rem] w-[1.9rem] shrink-0 items-center justify-center rounded-md bg-transparent text-gray-900 transition-colors hover:bg-gray-100 dark:text-gray-100 dark:hover:bg-gray-700/80"
          [title]="closeTitle">
          <lucide-icon [img]="xIcon" class="h-[1.18rem] w-[1.18rem]"></lucide-icon>
        </button>
      </div>

      <div
        class="modal-shell-body min-h-0 flex-1"
        [class.overflow-y-auto]="bodyScrollable"
        [class.overflow-hidden]="!bodyScrollable"
        [ngClass]="bodyClass">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>